import { useState, useEffect, React } from "react";
import { Content, Theme, Grid, Column, Tabs, TabList, Tab, TabPanels, TabPanel } from '@carbon/react';
import WHeader from '../../components/Header';
import { PerfilesTab, PermisosTab, UsuariosTab } from './Tabs';
import Cookies from "universal-cookie";

const Perfiles = () => {
  const cookies = new Cookies();
  
  if (!sessionStorage.getItem('rfc') || !cookies.get('rfc')) {
    window.location.href = "/#/";
  }

  
  const ColorHrLine = ({ color }) => (<hr style={{ color: color, backgroundColor: color, height: 2 }} />);
 
  const [showPerfiles, setShowPerfiles] = useState('');
  const [disabledTabPerfiles, setDisabledTabPerfiles] = useState(true);
  const [showPermisos, setShowPermisos] = useState('');
  const [disabledTabPermisos, setDisabledTabPermisos] = useState(true);
  const [showUsuarios, setShowUsuarios] = useState(false);


  useEffect(() => {
    var disabledPerfil = cookies.get("verPerfil");
    var disabledPermisos = cookies.get("verPermisos");

    setShowPerfiles((disabledPerfil === 'true')?true:false);
    setDisabledTabPerfiles((disabledPerfil === 'true')?false:true);
    setShowPermisos((disabledPermisos === 'true')?true:false);  
    setDisabledTabPermisos((disabledPermisos === 'true')?false:true);
  }, []);
  
  return (

    <Content>
      <Theme theme="g100">
        <WHeader />
      </Theme>

      <Grid>
        <Column lg={16} md={16} sm={16}>
          <h3 style={{ margin: '15px 0 20px' }}>Administración de perfiles.</h3>
          <ColorHrLine color="black" />
        </Column>
      </Grid>
      <br />
      <Grid>
        <Column lg={16} md={4} sm={4}>
          <Tabs >
            <TabList aria-label="List of tabs" >
           {/* {(showPerfiles && */}
              <Tab disabled={disabledTabPerfiles}>Perfiles</Tab>
           {/* )} */}
            {/* {(showPermisos && */}
              <Tab disabled={disabledTabPermisos}>Permisos</Tab>
             {/* )} */}
            {/* <Tab>Usuarios</Tab> */}
            </TabList>
            <TabPanels >
                {(showPerfiles &&
                  <TabPanel>
                    <PerfilesTab /> 
                  </TabPanel>
                )}
                {(showPermisos &&
                  <TabPanel>
                    <PermisosTab /> 
                  </TabPanel>
                )}
               {/*
              <TabPanel>
                {showUsuarios ? <UsuariosTab /> : null}
              </TabPanel>
              */}
            </TabPanels>
          </Tabs>
        </Column>
      </Grid>
    </Content>

  );
};

export default Perfiles;